<ng-container *notInProductCode="productCode.SGB">
  <div class="d-none d-lg-block">
    <div class="banner" role="banner"></div>
  </div>

  <fgb-page-header [pageTitle]="'lottos.page.title'" [backButtonLink]="'/'"></fgb-page-header>

  <div class="container mt-3">
    <fgbcl-lottos-list [isList]="true" [defaultSort]="0"></fgbcl-lottos-list>
  </div>
</ng-container>

<ng-container *inProductCode="productCode.SGB">
  <fgb-not-found-page></fgb-not-found-page>
</ng-container>
